import {
	GET_GENERATING_UNIT_FEATURES, SET_FEATURES_ERROR, SET_GENERATING_UNIT_FEATURES_RESULT, RESET_GENERATING_UNIT_FEATURES
} from "./GeneratingUnitFeaturesActionTypes";
import GeneratingUnitFeaturesService from "@/services/wind/GeneratingUnitFeaturesService";

const actions = {
	[GET_GENERATING_UNIT_FEATURES]: async({ commit }, monitoringElementId) =>
	{
		try
		{
			const response = await GeneratingUnitFeaturesService.GetGeneratingUnitFeatures(monitoringElementId);
			commit(SET_GENERATING_UNIT_FEATURES_RESULT, response);
		}
		catch (error)
		{
			commit(SET_FEATURES_ERROR, error);
		}
	},
	[RESET_GENERATING_UNIT_FEATURES]: ({ commit }) =>
	{
		commit(RESET_GENERATING_UNIT_FEATURES);
	}

};

export default { actions };